import { FullScreenLoader } from '../../../shared/components/fullscreen-loader/FullScreenLoader';

export const AuthorizePage = () => {
  return <FullScreenLoader />;
};
